import Vue from 'vue'
import Vuex from 'vuex'
import navigation from '@/store/modules/navigation'
import orders from '@/store/modules/orders'
import restaurant from '@/store/modules/restaurant'
import normalizer from '@/store/modules/normalizer'
import items from '@/store/modules/items'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    error: null,
    showError: false,
  },
  mutations: {
    ["SET_ERROR"]: function (state, error) {
      try {
        state.error = error.response.data.detail;
      } catch (err) {
        state.error = 'Unknown error';
      }
      state.showError = true;
    },
    ["UNSET_ERROR"]: function (state) {
      state.error = null;
      state.showError = false;
    },
  },
  actions: {
    setError({ commit }, error) {
      commit("SET_ERROR", error);
    },
    unsetError({ commit }) {
      commit("UNSET_ERROR");
    },
  },
  modules: {
    navigation,
    orders,
    restaurant,
    normalizer,
    items,
  }
})
